<template>
	<Row>
		<Col :span="24">
			<div class="dashboard-item-container">
				<div class="flex-wrapper align-baseline">
					<TypographyTitle :level="4" class="flex-grow">{{ header }}</TypographyTitle>
					<TypographyText v-if="timing != null" type="secondary">
						<HistoryOutlined class="timing-icon" />{{ timing }}
					</TypographyText>
				</div>
				<Card :bordered="false" class="dashboard-item-card">
					<slot></slot>
				</Card>
			</div>
		</Col>
	</Row>
</template>

<script>
import { TypographyTitle, Col, Row, Card, TypographyText } from 'ant-design-vue';
import { HistoryOutlined } from '@ant-design/icons-vue';

export default {
	components: {
		TypographyTitle, Col, Row, Card, TypographyText, HistoryOutlined,
	},
	props: {
		header: String,
		timing: {
			type: String,
			required: false,
		},
	},
}
</script>

<style scoped>
.dashboard-item-container {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.dashboard-item-card {
	flex-grow: 1;
}

.timing-icon {
	margin-inline-end: 4px;
}
</style>
